import { __extends } from "tslib";
import { detect } from 'detect-browser';
import Container from './container';
import { isBrowser, isNil, isString } from '../util/util';
import Timeline from '../animate/timeline';
import EventController from '../event/event-contoller';
var PX_SUFFIX = 'px';
var browser = detect();
var isFirefox = browser && browser.name === 'firefox';
var Canvas = /** @class */ (function (_super) {
    __extends(Canvas, _super);
    function Canvas(cfg) {
        var _this = _super.call(this, cfg) || this;
        _this.initContainer();
        _this.initDom();
        _this.initEvents();
        _this.initTimeline();
        return _this;
    }
    Canvas.prototype.getDefaultCfg = function () {
        var cfg = _super.prototype.getDefaultCfg.call(this);
        // set default cursor style for canvas
        cfg['cursor'] = 'default';
        // CSS transform ç®åå°æªç»è¿é¿æ¶é´éªè¯ï¼ä¸ºäºé¿åå½±åä¸å±ä¸å¡ï¼é»è®¤å³é­ï¼ä¸å±æéå¼å¯
        cfg['supportCSSTransform'] = false;
        return cfg;
    };
    /**
     * @protected
     * åå§åå®¹å¨
     */
    Canvas.prototype.initContainer = function () {
        var container = this.get('container');
        if (isString(container)) {
            container = document.getElementById(container);
            this.set('container', container);
        }
    };
    /**
     * @protected
     * åå§å DOM
     */
    Canvas.prototype.initDom = function () {
        var el = this.createDom();
        this.set('el', el);
        // éå å°å®¹å¨
        var container = this.get('container');
        container.appendChild(el);
        // è®¾ç½®åå§å®½åº¦
        this.setDOMSize(this.get('width'), this.get('height'));
    };
    /**
     * @protected
     * åå§åç»å®çäºä»¶
     */
    Canvas.prototype.initEvents = function () {
        var eventController = new EventController({
            canvas: this,
        });
        eventController.init();
        this.set('eventController', eventController);
    };
    /**
     * @protected
     * åå§åæ¶é´è½´
     */
    Canvas.prototype.initTimeline = function () {
        var timeline = new Timeline(this);
        this.set('timeline', timeline);
    };
    /**
     * @protected
     * ä¿®æ¹ç»å¸å¯¹åºç DOM çå¤§å°
     * @param {number} width  å®½åº¦
     * @param {number} height é«åº¦
     */
    Canvas.prototype.setDOMSize = function (width, height) {
        var el = this.get('el');
        if (isBrowser) {
            el.style.width = width + PX_SUFFIX;
            el.style.height = height + PX_SUFFIX;
        }
    };
    // å®ç°æ¥å£
    Canvas.prototype.changeSize = function (width, height) {
        this.setDOMSize(width, height);
        this.set('width', width);
        this.set('height', height);
        this.onCanvasChange('changeSize');
    };
    /**
     * è·åå½åçæ¸²æå¼æ
     * @return {Renderer} è¿åå½åçæ¸²æå¼æ
     */
    Canvas.prototype.getRenderer = function () {
        return this.get('renderer');
    };
    /**
     * è·åç»å¸ç cursor æ ·å¼
     * @return {Cursor}
     */
    Canvas.prototype.getCursor = function () {
        return this.get('cursor');
    };
    /**
     * è®¾ç½®ç»å¸ç cursor æ ·å¼
     * @param {Cursor} cursor  cursor æ ·å¼
     */
    Canvas.prototype.setCursor = function (cursor) {
        this.set('cursor', cursor);
        var el = this.get('el');
        if (isBrowser && el) {
            // ç´æ¥è®¾ç½®æ ·å¼ï¼ä¸ç­å¾é¼ æ ç§»å¨æ¶åè®¾ç½®
            el.style.cursor = cursor;
        }
    };
    // å®ç°æ¥å£
    Canvas.prototype.getPointByEvent = function (ev) {
        var supportCSSTransform = this.get('supportCSSTransform');
        if (supportCSSTransform) {
            // For Firefox <= 38
            if (isFirefox && !isNil(ev.layerX) && ev.layerX !== ev.offsetX) {
                return {
                    x: ev.layerX,
                    y: ev.layerY,
                };
            }
            if (!isNil(ev.offsetX)) {
                // For IE6+, Firefox >= 39, Chrome, Safari, Opera
                return {
                    x: ev.offsetX,
                    y: ev.offsetY,
                };
            }
        }
        // should calculate by self for other cases, like Safari in ios
        // TODO: support CSS transform
        var _a = this.getClientByEvent(ev), clientX = _a.x, clientY = _a.y;
        return this.getPointByClient(clientX, clientY);
    };
    // è·å touch äºä»¶ç clientX å clientY éè¦åç¬å¤ç
    Canvas.prototype.getClientByEvent = function (ev) {
        var clientInfo = ev;
        if (ev.touches) {
            if (ev.type === 'touchend') {
                clientInfo = ev.changedTouches[0];
            }
            else {
                clientInfo = ev.touches[0];
            }
        }
        return {
            x: clientInfo.clientX,
            y: clientInfo.clientY,
        };
    };
    // å®ç°æ¥å£
    Canvas.prototype.getPointByClient = function (clientX, clientY) {
        var el = this.get('el');
        var bbox = el.getBoundingClientRect();
        return {
            x: clientX - bbox.left,
            y: clientY - bbox.top,
        };
    };
    // å®ç°æ¥å£
    Canvas.prototype.getClientByPoint = function (x, y) {
        var el = this.get('el');
        var bbox = el.getBoundingClientRect();
        return {
            x: x + bbox.left,
            y: y + bbox.top,
        };
    };
    // å®ç°æ¥å£
    Canvas.prototype.draw = function () { };
    /**
     * @protected
     * éæ¯ DOM å®¹å¨
     */
    Canvas.prototype.removeDom = function () {
        var el = this.get('el');
        el.parentNode.removeChild(el);
    };
    /**
     * @protected
     * æ¸çææçäºä»¶
     */
    Canvas.prototype.clearEvents = function () {
        var eventController = this.get('eventController');
        eventController.destroy();
    };
    Canvas.prototype.isCanvas = function () {
        return true;
    };
    Canvas.prototype.getParent = function () {
        return null;
    };
    Canvas.prototype.destroy = function () {
        var timeline = this.get('timeline');
        if (this.get('destroyed')) {
            return;
        }
        this.clear();
        // ååå§åæ¶ç¸åé¡ºåºè°ç¨
        if (timeline) {
            // ç»å¸éæ¯æ¶èªå¨åæ­¢å¨ç»
            timeline.stop();
        }
        this.clearEvents();
        this.removeDom();
        _super.prototype.destroy.call(this);
    };
    return Canvas;
}(Container));
export default Canvas;
//# sourceMappingURL=canvas.js.map